<div class="modal-header">
  <h5 class="modal-title">Connexion / Création de compte</h5>
  <button type="button" class="btn-close" (click)="modal.close()"></button>
</div>

<div class="modal-body">
  <!-- Étape 1 : saisie du numéro -->
  <div *ngIf="currentStep === 1">
    <div class="mb-3">
      <label class="form-label">Numéro de téléphone</label>
      <p-inputNumber
        [(ngModel)]="numero"
        name="numero"
        inputId="numero"
        placeholder="Ex : 77 123 45 67"
        [allowEmpty]="true"
        [maxlength]="9"
      >
      </p-inputNumber>

      <div *ngIf="telephoneInvalide" class="text-danger small mt-1">
        <i class="bi bi-exclamation-circle me-1"></i>
        Le numéro doit contenir exactement 9 chiffres.
      </div>
    </div>
    <button
      type="button"
      class="btn btn-primary w-100"
      [disabled]="!numero"
      (click)="submitNumero()"
    >
      Suivant
    </button>
  </div>

  <!-- Étape 2 : mot de passe si utilisateur existe -->
  <div *ngIf="currentStep === 2">
    <div class="mb-3">
      <label class="form-label">Mot de passe</label>
      <div class="input-group">
        <input
          [type]="showPassword ? 'text' : 'password'"
          class="form-control"
          [(ngModel)]="password"
          name="password"
          placeholder="Entrez votre mot de passe"
          required
        />
        <button
          type="button"
          class="btn btn-outline-secondary"
          (click)="togglePassword()"
        >
          <i
            class="bi"
            [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'"
          ></i>
        </button>
      </div>
    </div>
    <button
      type="button"
      class="btn btn-success w-100"
      [disabled]="!password"
      (click)="login()"
    >
      Se connecter
    </button>
  </div>

  <!-- Étape 3 : création compte si utilisateur n'existe pas -->
  <div *ngIf="currentStep === 3">
    <div class="mb-3">
      <label class="form-label">Nom complet</label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="nouvelUtilisateur.nom"
        name="nom"
        required
      />
    </div>
    <div class="mb-3">
      <label class="form-label">Mot de passe</label>
      <div class="input-group">
        <input
          [type]="showPasswordCreation ? 'text' : 'password'"
          class="form-control"
          [(ngModel)]="nouvelUtilisateur.password"
          name="password"
          required
        />
        <button
          type="button"
          class="btn btn-outline-secondary"
          (click)="togglePasswordCreation()"
        >
          <i
            class="bi"
            [ngClass]="showPasswordCreation ? 'bi-eye-slash' : 'bi-eye'"
          ></i>
        </button>
      </div>
      <div
        class="form-text"
        [ngClass]="
          nouvelUtilisateur.password && !isPasswordValid()
            ? 'text-danger'
            : 'text-muted'
        "
      >
        8 caractères min., avec majuscule, minuscule, chiffre et caractère
        spécial.
      </div>
    </div>
    <button
      type="button"
      class="btn btn-primary w-100"
      [disabled]="!isPasswordValid()"
      (click)="creerCompte()"
    >
      Créer un compte
    </button>
  </div>
</div>
